import { Link, useParams } from "react-router-dom";
import MainFooter from "../../module/footer/main_footer";
import SubNavBar from "../../module/nav_bar/sub_nav_bar";
import "./intro_page.css";
import GreetingPage from "./greeting_page";
import FacilityPage from "./facility_page";
import RoadmapPage from "./roadmap_page";
import FixedBtn from "../../module/fixed_btn/fixed_btn";

function IntroPage() {
  const { contents } = useParams();
  let content, title;
  if (contents === "greeting") {
    content = <GreetingPage />;
    title = "인사말";
  } else if (contents === "facility") {
    content = <FacilityPage />;
    title = "시설소개";
  } else if (contents === "roadmap") {
    content = <RoadmapPage />;
    title = "오시는 길";
  }

  return (
    <div className="intro_page">
      <nav>
        <SubNavBar />
      </nav>
      <div className="page_header">
        <div className="page_title">{title}</div>
        <ul className="sub_nav" id="intro">
          <Link
            to="/intro/greeting"
            className="link_btn"
            id={contents === "greeting" ? "active" : ""}
          >
            <li>인사말</li>
          </Link>
          <Link
            to="/intro/facility"
            className="link_btn"
            id={contents === "facility" ? "active" : ""}
          >
            <li>시설소개</li>
          </Link>
          <Link
            to="/intro/roadmap"
            className="link_btn"
            id={contents === "roadmap" ? "active" : ""}
          >
            <li>오시는 길</li>
          </Link>
        </ul>
      </div>
      <main className="intro_main">{content}</main>
      <FixedBtn />
      <footer>
        <MainFooter />
      </footer>
    </div>
  );
}

export default IntroPage;
